import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { MenuNavigationService, PageNotificationService } from '@signature-it/ngx-generic/services';

declare let _: any;


interface Nav {
    children?: Array<Nav>;
    url: string;
    name: string;
    slices?: Array<any>
}

type TopNavigation = Nav[]; // Now it's just an array of NewsLetter objects


@Component({
    selector: 'main-top-navigation',
    templateUrl: './main-top-navigation.html',
    styleUrls: ['./main-top-navigation.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class MainTopNavigationComponentGeneric implements OnInit {

	topNavigation: TopNavigation = [];
	@Input() initialName: string;

    constructor(protected notifySvc: PageNotificationService,
                protected navSvc: MenuNavigationService) {
    }

	ngOnInit() {
		this.getTopNavigation(this.initialName ? this.initialName : null);
	}

    getTopNavigation(name?: string) {
        this.navSvc.getTopNavigation(name)
            .subscribe(
                res => {
                    let nav = res;
                    nav.forEach(function (section) {
                        section.children.forEach(function (item) {
                            if(_.isArray(item.children) && item.children.length) {
                                let slice = [];
                                item['slices'] = [];
                                for (let i = 0; i <= item.children.length / 10; i++) {
                                    slice = item.children.slice(i * 10, i*10 + 10);
                                    if(slice.length) {
                                        item['slices'].push(slice);
                                    }
                                }
                            }
                        });
                    });
                    this.topNavigation = nav;
                },
                error => { this.notifySvc.set(error).show(); }
            );
    }
}
